import { useState } from 'react'
import toast from 'react-hot-toast'
import { Loader2, Mail } from 'lucide-react'
import { connectGmail } from '../../services/api.js'

/**
 * « Connecter Gmail » : ouvre l'écran Google qui autorise JLP à envoyer des e-mails depuis
 * Gmail (séparé de la connexion Google). Au retour, GmailConnectResult affiche le résultat.
 */
export default function ConnectGmailButton({ className = 'comm-btn comm-btn-primary', style, children = 'Connecter Gmail' }) {
  const [loading, setLoading] = useState(false)

  const handleClick = async () => {
    setLoading(true)
    try {
      const { url } = await connectGmail(window.location.pathname)
      window.location.href = url
    } catch {
      setLoading(false)
      toast.error('Impossible de lancer la connexion Gmail')
    }
  }

  return (
    <button type="button" onClick={handleClick} disabled={loading} className={className} style={style}>
      {loading ? <Loader2 size={18} className="animate-spin" /> : <Mail size={18} />}
      {children}
    </button>
  )
}
